<template>
  <div @contextmenu.prevent="" class="ptt-son">
      <div class="ptt-nr">
     
    <div class="btn-tan">

       <ptsontwo :threepdf='childrendata' v-show="tabthree"></ptsontwo>
   <ptsonthree v-if="showimgppt"></ptsonthree>

      <!-- 左边展示 -->
      <div v-show="tabone" class="btn-you">
        <div v-show="vimgshow" class="vibo">
          <i @click="videopl()" class="vinco-bo"></i>
 <img class="vimgpt" :src="'http://ke.yunlearning.com'+zpptson.cover_img" alt="###">
        </div>
       
        <video v-show="videoshow" id="videopt" :src="'http://ke.yunlearning.com'+zpptson.video"  preload="auto" controls>
       

          您的浏览器不支持 video 标签。
        </video>
      </div>
    
     
      <!-- 右边 -->
      <div class="btn-tan-left">
        <div class="btn-tan-left-left2">
          <div class="btn-tan-left-title">
            <p>{{zpptson.title}}</p>
            <div class="btn-tan-left-bert">
                 <i></i>
            
            <span class="btn-tan-left-title-name">课程票数：{{zpptson.praise}}票</span>
            <span class="btn-tan-left-title-date2">上传时间 :</span>
            <span class="btn-tan-left-title-date">{{upvideotime}}</span>
            </div>
         
            
          </div>
          <div class="btn-tan-left-tab">         
            <div @click="taboneo()" class="ptabc" :class="active == activetwoa ? 'ptab1':''" href="###">
              <span>微课资源</span>
            </div>
            <div  @click="tabtwoo()" class="ptab2" :class="active == activetwob ? 'ptab1':''" href="###">
              <span>ppt资源</span>
            </div>
            <div  @click="tabthreeo()" class="ptab3" :class="active == activetwoc ? 'ptab1':''" href="###">
              <span>课程教案</span>
            </div>
          </div>
          <p class="btn-tan-left-miaoshu">
        {{zpptson.message}}
          </p>

          <div class="btn-shenhe">
            <span v-if="is_pears == 0" @click.once="ptsonparise()" class="mp4toup">{{parsetxt}}</span>
              <span v-if="is_pears == 1" @click.once="ptsonparise()" class="mp4toupb">{{parsetxts}}</span>
     
 <span @click="pjrou()" class="mp4pj">课程评价</span>
         
           

          </div>
          
        </div>
      </div>
    </div>
 </div>
    <botTom></botTom>
  </div>
</template>

<script>
import ptson from "../css/PtSon.css";
import botTom from "./BotTom";
import ptsontwo from "./PtSontwo";
import ptsonthree from "./PtSonthree";
import axios from 'axios';
export default {
    data(){
        return{
tabone:true,
tabtwo:false,
tabthree:false,
zpptson:'',
upvideotime:'',
childrendata:'22',
videoshow:false,
vimgshow:true,
parsetxt:'投TA一票',
parsetxts:'您已投过票',
buf:0,
is_pears:'',
showimgppt:false,
active:1,
activetwoa:1,
activetwob:2,
activetwoc:3,
        }
    },
  components: {
    botTom,ptsontwo,ptsonthree
  },

  methods: {
      taboneo(){
          this.tabone = true;
          this.showimgppt = false;
          // this.tabtwo =false;
          this.tabthree = false;
        
          this.active = 1;
          
      
      },
      tabtwoo(){
          this.tabone = false;
          // this.tabtwo =true;
           this.showimgppt = true;
          this.tabthree = false;
       
            document.getElementById('videopt').pause();
        this.active = 2;
      },
      tabthreeo(){
          this.tabone = false;
           this.showimgppt = false;
          // this.tabtwo =false;
          this.tabthree = true;
       
            document.getElementById('videopt').pause()
          this.active = 3;
      },
      //viode 播放
      videopl(){
        this.vimgshow = false;
        this.videoshow = true;
        let vidoplay = document.getElementById('videopt');
        vidoplay.play();
      },
                // 时间
 timestampToTime(timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var  Y = date.getFullYear() + '';
  var   M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var   D = this.change(date.getDate()) + '';
  var   h = this.change(date.getHours()) + ':';
  var   m = this.change(date.getMinutes()) + ':';
  var   s = this.change(date.getSeconds());
    return Y+'-'+M+'-'+D;
},
change(t) {
    if (t < 10) {
        return "0" + t;
    } else {
        return t;
    }
 
},
      // 作品详情信息
      ptsonallv(){
        let tokens = JSON.parse(localStorage.getItem("userinfo")).token;
        let id =sessionStorage.getItem('id');
        let fa = new window.FormData;
        fa.append('token',tokens);
        fa.append('id',id);
        axios({
          method:'post',
          url:this.$apiUrl+'/index.php/course/courseInfo',
          data:fa
        }).then(res =>{
         
          this.zpptson = res.data.data;
          this.is_pears = res.data.data.is_praise;
      this.childrendata =  res.data.data.teach_img;
      //教案图片
      this.$store.commit('pdfresdata',res.data.data.teach_img); 
      //ppt图片
  this.$store.commit('pptimgsUrl',res.data.data.ppt_imgs);
  //作品信息
  this.$store.commit('zpdataall',res.data.data);
  // 时间

                 var t=this.zpptson.create_time;
this.upvideotime = this.timestampToTime(t);
        }).catch(error =>{
          console.log(error,'作品error')
        })
      },
      // 投票
      ptsonparise(){
        
        let tokens = JSON.parse(localStorage.getItem("userinfo")).token;
        let id = JSON.parse(sessionStorage.getItem("id"));
        let fa = new window.FormData;
        fa.append('token',tokens);
        fa.append('id',id);
        axios({
          method:'post',
          url:this.$apiUrl+'/index.php/user/praise',
          data:fa
        }).then(res =>{
          if (res.data.code == 0) {
            // this.parsetxts = '您已过投票'
              this.$message.error({
                message:'今日投票次数已用完，请明天再来！',
                offset:200,

              });
          }else if (res.data.code == 1) {
            this.parsetxt = '投票成功'
           this.$message({
             message:'投票成功！！！',
             offset:200,
             type:'success'
           });
           this.ptsonallv();
          }else if (res.data.code == -1) {
             localStorage.clear();
             this.$router.push({path:'/denglu'})
          }
  
        }).catch(error =>{
          console.log(error,'作品error')
        })
      },
          pjrou(){
   this.$router.push({path:'/weikeson'});
     let rzstutas = JSON.parse(localStorage.getItem('grxinxi')).status; //信息审核状
   if (rzstutas== -1) {
        this.$router.go(0);
   }
      },

  },
  computed:{
    _thiszpid(){
      return this.$store.state.id;
    }
  },
  watch: {
    $route: {
      handler: function(route) {
      
        this.pathcas = route.path;
      },
      immediate: true
    }
  },
  mounted(){
    this.ptsonallv();
     
document.getElementById('videopt').controlsList = "nodownload" ;

   if (this.pathcas=="/ptson") {
         //禁用右键
    document.oncontextmenu = function () { return false; };
          // 禁止任何键盘敲击事件（防止F12和shift+ctrl+i调起开发者工具） 
    window.onkeydown = window.onkeyup = window.onkeypress = function (event) { 
        if(event.code == 'F12'){
            window.event.returnValue = false; 
            return false;
        }
        
    }
  }
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/PtSon.vue